import { ProjectType } from '@scale/shared/defaults';
import { IProjectJson } from '@scale/shared/types/project';
import { Project } from 'dashboard/types';
import { getFilterParams } from 'dashboard/hooks/useBatchTasks';
import { IFilters } from 'dashboard/hooks/useFilters';
import { ParsedQuery } from 'query-string';

export function isRapidOrStudioProject(
  project: IProjectJson | string | undefined | null | Project,
) {
  return isRapidProject(project) || isStudioProject(project);
}

export function isRapidProject(project: IProjectJson | string | undefined | null | Project) {
  return !!project && typeof project !== 'string' && project.projectType === ProjectType.SelfServe;
}

export function isStudioProject(project: IProjectJson | string | undefined | null | Project) {
  return !!project && typeof project !== 'string' && project.projectType === ProjectType.Studio;
}

export function isRapidOrStudioProjectType(projectType: ProjectType | string | undefined | null) {
  return isRapidProjectType(projectType) || isStudioProjectType(projectType);
}

function isRapidProjectType(projectType: ProjectType | string | undefined | null) {
  return !!projectType && projectType === ProjectType.SelfServe;
}

function isStudioProjectType(projectType: ProjectType | string | undefined | null) {
  return !!projectType && projectType === ProjectType.Studio;
}

export function isProProjectType(projectType: ProjectType | string | undefined | null) {
  return !projectType || projectType === '' || projectType === ProjectType.Pro;
}

interface DecodedQuery {
  [key: string]: string | boolean | number;
}

function isNumeric(value: string) {
  return /^-?\d+$/.test(value);
}

// used for audits from an individual studio batch page
export function decodeIndividualAuditQuery(query: ParsedQuery, filterValues: IFilters) {
  const { search, batchId } = query;

  // case where we searched by taskid from the batches page
  if (search) {
    return { search };
  }

  // first filter the userFilter hook
  const initialFilter = getFilterParams(filterValues, batchId as string, true);
  const keysToOmit = new Set(['taskId', 'batchId', 'individualAudit', 'spoof']);
  // then take other fields that we need in our query like offset and limit
  const decodedQuery: DecodedQuery = {};
  for (const key in query) {
    const currVal = query[key] as string;

    if (!keysToOmit.has(key)) {
      if (initialFilter[key]) {
        decodedQuery[key] = initialFilter[key];
      } else if (currVal === 'true') {
        decodedQuery[key] = true;
      } else if (currVal === 'false') {
        decodedQuery[key] = false;
      } else if (isNumeric(currVal)) {
        decodedQuery[key] = parseInt(currVal);
      } else {
        decodedQuery[key] = currVal;
      }
    }
  }

  return decodedQuery;
}
